module.exports = __webpack_public_path__ + "media/images/badges/rumble/milestone-500-Active-Rumble-0f5c79f2d54f5406824cf994d81f42b1.png";